export default function equalizeFunction(equality, value) {
  switch (equality) {
    case 'greater':
      return value > 0;

    case 'greaterorequal':
      return value >= 0;

    default:
      return value === 0;
  }
}
